import axios from "axios";
import env from "../../env/env"
import {auth} from "../auth/auth"

// Global axios response interceptor to handle auth errors (401/403)
// Ensures any unauthorized/forbidden response logs the user out and returns to login.
if (typeof window !== 'undefined' && !axios.__intoitAuthInterceptorInstalled) {
    axios.__intoitAuthInterceptorInstalled = true;
    axios.interceptors.response.use(
        response => response,
        error => {
            try {
                const status = error?.response?.status;
                if (status === 401 || status === 403) {
                    // Clear auth and any persisted UI state
                    try { auth.logout(); } catch (_) { /* ignore */ }
                    // Force reload to reset app state to login screen
                    try { window.location.reload(); } catch (_) { /* ignore */ }
                }
            } catch (_) {
                // ignore
            }
            return Promise.reject(error);
        }
    );
}

const baseHeaders = () => {
    return {
        token: auth.sessionToken,
        Token: auth.sessionToken,
    }
}

const login = async (email, password) => {
    return await axios.post(
        `${env.API_URL}/api/v1/admin/login`,
        {
            email: email,
            password: password
        })

}

const getUsers = async () => {
    return await axios.get(`${env.API_URL}/api/v1/admin/users`, {
        headers: {...baseHeaders()},
    })
}

const getPreferences = async () => {
    return await axios.get(`${env.API_URL}/api/v1/admin/preferences`, {
        headers: {...baseHeaders()},
    })
}

const getPreferencesByUserID = async (userID) => {
    return await axios.get(`${env.API_URL}/api/v1/admin/users/${userID}/preferences`, {
        headers: {...baseHeaders()},
    })
}

const createPreference = async (data) => {
    return await axios.post(`${env.API_URL}/api/v1/admin/preferences`, data, {headers: {...baseHeaders()},})
}

const updatePreference = async (id, data) => {
    return await axios.put(`${env.API_URL}/api/v1/admin/preferences/${id}`, data, {headers: {...baseHeaders()},})
}

const deletePreference = async (id) => {
    return await axios.delete(`${env.API_URL}/api/v1/admin/preferences/${id}`, {headers: {...baseHeaders()},})
}

const deactivateUser = async (userId) => {
    return await axios.delete(`${env.API_URL}/api/v1/admin/users/${userId}`, {headers: {...baseHeaders()},})
}

const getUsageRecords = async () => {
    return await axios.get(`${env.API_URL}/api/v1/admin/usage-records`, {
        headers: {...baseHeaders()},
    })
}

const getUsageRecord = async (id) => {
    return await axios.get(`${env.API_URL}/api/v1/admin/usage-records/${id}`, {
        headers: {...baseHeaders()},
    })
}

const uploadPreference = async (file) => {
    const uploadFileData = new FormData();
    uploadFileData.append("file", file);

    return await axios.post(`${env.API_URL}/api/v1/admin/preferences/import`, uploadFileData, {
        headers: {
            ...baseHeaders(),
            'Content-Type': 'multipart/form-data'
        }
    });
}

const exportPreferences = async () => {
    return await axios.get(`${env.API_URL}/api/v1/admin/preferences/export`, {
        headers: { ...baseHeaders() },
        responseType: 'blob'
    })
}

const logoutRequest = async () => {
    // Uses X-Auth-Token header as required by backend for logout
    return await axios.post(`${env.API_URL}/api/v1/admin/logout`, {}, {
        headers: {
            ...baseHeaders(),
            'X-Auth-Token': auth.sessionToken,
        },
    })
}

export {
    login,
    getUsers,
    deactivateUser,
    getPreferences,
    getPreferencesByUserID,
    createPreference,
    updatePreference,
    getUsageRecords,
    getUsageRecord,
    deletePreference,
    uploadPreference,
    exportPreferences,
    logoutRequest,
}
